export { default as Avatar } from './Avatar';
export { default as GroupAvatars } from './AvatarGroup';
export { default as AvatarProfile } from './AvatarProfileWrapper';
export type { AvatarGroupPersonType } from './AvatarGroup';
export { AvatarSizeEnum } from './AvatarGroup';

export type { AvatarColor, Props as AvatarProps } from './Avatar';
